export class CreateAccountModel {
  constructor(
    public Email: string = '',
    public ReEmail: string = '',
    public NewPassword: string = '',
    public RePassword: string = '',
    public FName: string = '',
    public LName: string = '',
    public SelectedCountry: CountryListModel = new CountryListModel(),
    public ZipCode: string = '',
    public SelectedProvince: ProvinceModel = new ProvinceModel(),
    public OtherInstitue: string = '',
    public CountryList_ForAPI: CountryListModel[] = [],
    public SelectedInstitute: InstituteListModel = new InstituteListModel(),
    public Institute: string = '',
    public Province: string = '',

    public ProgramID?: null,
    public YearsId?: null,
    public GraduationYear? : null,
    public ProgramList: ProgramModel[] = [],
    public GraduationyearList: GraduationYearModel[] = [],
    //

    public AppId: number = 0,
    public AccountID: number = 0,
    public FirstName: string = '',
    public LastName: string = '',
    public Password: string = '',
    public IsActive: boolean = false,
    public InstituteID: number = 0,
    public InstituteName: string = '',
    public CountryID: number = 0,
    public ProvinceID: number = 0,
    public URL: string = '',
    public HouseNumber: string = '',
    public Street: string = '',
    public City: string = '',
    public State: string = '',
    public FacebookID: string = '',
    public AccountParentID: number = 0,
    public CreateDateTime: number = 0,
    public UpdateDateTime: number = 0,
    public LastLoginDate: number = 0,
    public AccountTypeName: string = '',
    public Confirmed: boolean = false,
    public SelectedCountryID: number = 0,
    public IsEmailOption:boolean=true
  ) { }
}



export class CountryListModel {
  constructor(
    public ID: number = 0,
    public Name: string = null,
    public CountryCode: string = null
  ) { }
}

export class InstituteListModel {
  constructor(
    public InstituteName: string = null,
    public InstituteID?: number
  ) {
    this.InstituteID = null;

  }
}
export class ProvinceModel {

  constructor(
    public ProvinceID?: number,
    public Description: string = null,
    public SalesRepID?: number,
    public ProvinceCode: string = null

  ) { }
}

export class ProgramModel {
  constructor(
    public ProgramID?: number,
    public ProgCode: string = '',
    public Description: string = '',
    public INF_ProgramID: string = ''
  ) { }
}

export class GraduationYearModel {
  constructor(
    public YearsId?: number,
    public Description: string = ''
  ) { }
}


// WEBPACK FOOTER //
// ./src/app/core/models/CreateAccount.model.ts